import { NodeEntity } from "./NodeEntity";
import { QAuxLineElement } from "./QAuxLineElement";

export class QPageAuxLine {
  constructor() {
    //this.fPageAuxDesc = null;
    this.fNodeEntity1 = null;
    this.fNodeEntity2 = null;
    this.fLayout = null;
    this.fAuxLineElement = null;
    this.fID = null;
    this.fCtlPoints = null;
    // Other stuff
  }

  SetID(auxLineID) {
    this.fID = auxLineID;
  }

  GetID() {
    return this.fID;
  }

  SetNodeEntity(nodeEntity) {
    if (this.fNodeEntity1 === null) {
      this.fNodeEntity1 = nodeEntity;
    } else {
      this.fNodeEntity2 = nodeEntity;
    }
  }

  GetNodeEntities() {
    var entities = { source: this.fNodeEntity1, target: this.fNodeEntity2 };
    return entities;
  }

  UpdateLine(layout, style, ctrlPoints) {
    if (!this.fCtlPoints) {
      this.fCtlPoints = [];
    }
    this.fCtlPoints.length = 0;
    this.fLayout = layout;

    if (typeof style !== "undefined") {
      this.fStyle = style;
    }

    if (typeof ctrlPoints !== "undefined") {
      this.fCtlPoints = ctrlPoints.slice(0);
    }

    if (!this.fAuxLineElement) {
      this.fAuxLineElement = new QAuxLineElement();
      this.fAuxLineElement.InitAuxLine(layout);
    }

    this.fAuxLineElement.UpdateControlPoints(this.fCtlPoints);
    this.fAuxLineElement.UpdateDimensions();
    this.fAuxLineElement.fStyle = style;
  }

  UpdateElement(parentPanel) {
    if (!this.fAuxLineElement) {
      return;
    }

    this.fAuxLineElement.UpdateAuxLineElement(parentPanel);
    parentPanel.PushElement(this.fAuxLineElement);
  }
}
